<template>
  <div id="Doctor" class="print-content">
    <div style="margin-top: 20px">
      <div style="display: flex; flex-direction: column">
        <span style="font-size: 38px; font-weight: 800"
          >{{ type }} Expenses {{ new Date().getFullYear() }}</span
        >
        <span style="font-size: 30px; font-weight: 600">Common Expenses</span>
        <span
          v-if="fromDate"
          style="font-size: 30px; font-weight: 600; text-align: right"
        >
          {{ fromDate }} - {{ toDate || today }}
        </span>
        <span
          v-else
          style="font-size: 30px; font-weight: 600; text-align: right"
        >
          {{ today }}
        </span>
      </div>
      <table
        style="
          width: 100%;
          border-collapse: collapse;
          margin: 20px auto;
          overflow: hidden;
          border: 3px solid black;
        "
      >
        <tr>
          <th
            style="
              padding: 8px;
              text-align: center;
              background-color: #848884;
              border-bottom: 1px solid;
              border-right: 1px solid;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                color: white;
              "
            >
              <span style="font-size: 33px; font-weight: 600">Doctor</span>
            </div>
          </th>
          <th
            style="
              padding: 8px;
              text-align: center;
              background-color: #848884;
              border-bottom: 1px solid;
              border-right: 1px solid;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                color: white;
              "
            >
              <span style="font-size: 33px; font-weight: 600">Description</span>
            </div>
          </th>
          <th
            style="
              padding: 8px;
              text-align: center;
              border-bottom: 1px solid;
              background-color: #848884;
              border-right: 1px solid;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                color: white;
              "
            >
              <span style="font-size: 33px; font-weight: 600">Price IQD</span>
            </div>
          </th>
          <th
            style="
              padding: 8px;
              text-align: center;
              border-bottom: 1px solid;
              background-color: #848884;
              border-right: 1px solid;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                color: white;
              "
            >
              <span style="font-size: 33px; font-weight: 600">Price $</span>
            </div>
          </th>
          <th
            style="
              padding: 8px;
              text-align: center;
              border-bottom: 1px solid;
              background-color: #848884;
              border-right: 1px solid;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                color: white;
              "
            >
              <span style="font-size: 33px; font-weight: 600"
                >Exchange rate</span
              >
            </div>
          </th>
        </tr>
        <tbody>
          <template v-for="(row) in data">
            <tr>
              <td
                style="
                  padding: 8px;
                  text-align: center;
                  border-bottom: 1px solid #333;
                  border-right: 1px solid #333;
                  font-size: 33px;
                "
              >
                {{ row.doctor.name }}
              </td>
              <td
                style="
                  padding: 8px;
                  text-align: center;
                  border-bottom: 1px solid #333;
                  border-right: 1px solid #333;
                  font-size: 33px;
                "
              >
                {{ row.description }}
              </td>
              <td
                style="
                  padding: 8px;
                  text-align: center;
                  border-bottom: 1px solid #333;
                  border-left: 1px solid #333;
                  border-right: 1px solid #333;
                  font-size: 33px;
                "
              >
                {{ row.amount_iqd }}
              </td>
              <td
                style="
                  padding: 8px;
                  text-align: center;
                  border-bottom: 1px solid #333;
                  border-left: 1px solid #333;
                  font-size: 33px;
                "
              >
                {{ Number(row.amount_usd).toFixed(1) }}
              </td>
              <td
                style="
                  padding: 8px;
                  text-align: center;
                  border-bottom: 1px solid;
                  border-left: 1px solid;
                  border-right: 1px solid;
                  font-size: 33px;
                "
              >
                {{ row.currency_ex_rate }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    fromDate: {
      type: String,
      required: false,
    },
    toDate: {
      type: String,
      required: false,
    },
  },
  computed: {
    today() {
      return new Date().toISOString().split("T")[0];
    },
  },

};
</script>
<style scoped>
.print-content {
  display: none;
}
.rtl {
  direction: rtl;
}
.ltr {
  direction: ltr;
}
/* Show the print content when printing */
@media print {
  .print-content {
    display: block;
  }
  button {
    display: none; /* Hide the button when printing */
  }
}
p.solid {
  border-style: solid;
}
table {
  background-color: #333;
  width: 60%;
  border-collapse: separate;
  border-spacing: 0;
  margin: 20px auto;
  border-radius: 10px;
  overflow: hidden;
  border: 3px solid #333;
}
th,
td {
  padding: 8px;
  text-align: center;
  border-bottom: 1px solid #333;
}
th {
  background-color: #f2f2f2;
}
tr:last-child td {
  border-bottom: none;
}
</style>
<!--  -->
